import * as Types from '../../../gql.generated';

import { FixedRatesFragmentFragment } from '../../AdminProvingGroundsView/FixedRatesFragment.generated';
import { TransportFragmentFragment } from '../../AdminProvingGroundsView/transportFragment.generated';
import { ChangeTrackingFragmentFragment } from './changeFragment.generated';
import gql from 'graphql-tag';
import { ChangeTrackingFragmentFragmentDoc } from './changeFragment.generated';
import { TransportFragmentFragmentDoc } from '../../AdminProvingGroundsView/transportFragment.generated';
import { FixedRatesFragmentFragmentDoc } from '../../AdminProvingGroundsView/FixedRatesFragment.generated';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type ProvingQueryVariables = {
  id: Types.Scalars['ID']
};


export type ProvingQuery = (
  { __typename?: 'Query' }
  & { proving: Types.Maybe<(
    { __typename?: 'Proving' }
    & Pick<Types.Proving, '_id' | '_snapshotTimestamp' | 'deletionPeriod' | 'deletionRule' | 'id' | 'type' | 'title' | 'declined' | 'created' | 'modified' | 'dateFrom' | 'dateTo' | 'description' | 'declineReason' | 'status' | 'department' | 'leadingDepartment' | 'costCentre' | 'sumOfCosts' | 'effectiveSumOfCosts' | 'newMails' | 'dvtWvtCheckDisabled' | 'headOfProvingCheckDisabled' | 'multiSelectEditorCheckEnabled' | 'serviceTeamIsEditing' | 'hrgIsEditing' | 'multiSelectResponsibleCheckEnabled' | 'multiSelectSubstituteCheckEnabled' | 'adminsOnlyResponsibleCheckEnabled' | 'adminsOnlySubstituteCheckEnabled' | 'enableGroups' | 'hasIncompleteBookings' | 'annotationParticipants' | 'annotationVehicles' | 'annotationResourceRequirements' | 'annotationResourceBookings' | 'annotationForms' | 'annotationMaterials' | 'annotationFiles' | 'materialsExportedToSAP'>
    & { _changes: Types.Maybe<{ __typename?: 'ProvingChangeTracking' }
      & ChangeTrackingFragmentFragment
    >, documents: Types.Maybe<Array<(
      { __typename?: 'ProvingDocument' }
      & Pick<Types.ProvingDocument, '_id' | 'uri' | 'name' | 'block' | 'participantId' | 'type'>
    )>>, maintenanceHead: Types.Maybe<Array<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'type' | 'name' | 'firstName' | 'lastName' | 'email' | 'department' | 'upn' | 'external' | 'companyName' | 'userType'>
    )>>, declinedBy: Types.Maybe<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'type' | 'name' | 'firstName' | 'lastName' | 'email' | 'department' | 'upn' | 'external' | 'companyName' | 'userType'>
    )>, createdBy: (
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'type' | 'name' | 'firstName' | 'lastName' | 'email' | 'department' | 'upn' | 'external' | 'companyName' | 'userType'>
    ), modifiedBy: (
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'type' | 'name' | 'firstName' | 'lastName' | 'email' | 'department' | 'upn' | 'external' | 'companyName' | 'userType'>
    ), statusChange: Types.Maybe<(
      { __typename?: 'ProvingChange' }
      & Pick<Types.ProvingChange, '_id' | 'provingId' | 'status' | 'created' | 'resolved'>
      & { change: (
        { __typename?: 'ProvingChangeDetails' }
        & Pick<Types.ProvingChangeDetails, 'oldValue' | 'key' | 'type' | 'path' | 'valueType'>
      ), createdBy: (
        { __typename?: 'User' }
        & Pick<Types.User, '_id' | 'upn' | 'name' | 'type' | 'firstName' | 'lastName' | 'external' | 'companyName' | 'userType'>
      ), resolvedBy: Types.Maybe<(
        { __typename?: 'User' }
        & Pick<Types.User, '_id' | 'upn' | 'name' | 'type' | 'firstName' | 'lastName' | 'external' | 'companyName' | 'userType'>
      )> }
    )>, provingGround: Types.Maybe<(
      { __typename?: 'ProvingGround' }
      & Pick<Types.ProvingGround, '_id' | 'title' | 'countryCode' | 'abbr' | 'specialNote' | 'inactive' | 'noteHeaderVehicles' | 'noteVehicles' | 'noteHeaderMaterials' | 'noteMaterials' | 'hideFlight' | 'hideFerryConnection' | 'hideNordschleife' | 'hideHotels' | 'skipClearing' | 'useUsageTimespansOnly' | 'drivingLessons' | 'vehicleTransportToDays' | 'vehicleTransportFromDays' | 'racewayHours' | 'showNMF' | 'showSpecialUsage' | 'deleteEditor' | 'block1' | 'block2' | 'block3' | 'block4' | 'block5' | 'block6' | 'block7' | 'block8' | 'block9' | 'block10' | 'block1Note' | 'block2Note' | 'block3Note' | 'block4Note' | 'block5Note' | 'block6Note' | 'block7Note' | 'block8Note' | 'block9Note' | 'block10Note' | 'block1Files' | 'block2Files' | 'block3Files' | 'block4Files' | 'block5Files' | 'block6Files' | 'block7Files' | 'block8Files' | 'block9Files' | 'block10Files'>
      & { outboundTransportSender: Types.Maybe<{ __typename?: 'SenderRecipient' }
        & TransportFragmentFragment
      >, outboundTransportRecipient: Types.Maybe<{ __typename?: 'SenderRecipient' }
        & TransportFragmentFragment
      >, returnTransportSender: Types.Maybe<{ __typename?: 'SenderRecipient' }
        & TransportFragmentFragment
      >, returnTransportRecipient: Types.Maybe<{ __typename?: 'SenderRecipient' }
        & TransportFragmentFragment
      >, fileTemplates: Types.Maybe<Array<(
        { __typename?: 'FileTemplate' }
        & Pick<Types.FileTemplate, '_id' | 'fileName' | 'uri' | 'type' | 'cellMapping'>
        & { provingGround: Types.Maybe<(
          { __typename?: 'ProvingGround' }
          & Pick<Types.ProvingGround, '_id'>
        )> }
      )>>, editors: Types.Maybe<Array<(
        { __typename?: 'User' }
        & Pick<Types.User, '_id' | 'type' | 'name' | 'firstName' | 'lastName' | 'email' | 'department' | 'upn' | 'external' | 'companyName' | 'userType'>
      )>>, clearing: Types.Maybe<Array<(
        { __typename?: 'User' }
        & Pick<Types.User, '_id' | 'type' | 'name' | 'firstName' | 'lastName' | 'email' | 'department' | 'upn' | 'external' | 'companyName' | 'userType'>
      )>>, resourceManagers: Types.Maybe<Array<(
        { __typename?: 'User' }
        & Pick<Types.User, '_id' | 'type' | 'name' | 'firstName' | 'lastName' | 'email' | 'department' | 'upn' | 'external' | 'companyName' | 'userType'>
      )>>, authorizedEditors: Types.Maybe<Array<(
        { __typename?: 'User' }
        & Pick<Types.User, '_id' | 'type' | 'name' | 'firstName' | 'lastName' | 'email' | 'department' | 'upn' | 'external' | 'companyName' | 'userType'>
      )>>, fixedRates: Types.Maybe<{ __typename?: 'FixedRates' }
        & FixedRatesFragmentFragment
      > }
    )>, responsible: Array<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'type' | 'name' | 'firstName' | 'lastName' | 'email' | 'department' | 'upn' | 'external' | 'companyName' | 'userType'>
    )>, editor: Types.Maybe<Array<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'type' | 'name' | 'firstName' | 'lastName' | 'email' | 'department' | 'upn' | 'external' | 'companyName' | 'userType'>
    )>>, resourceManager: Types.Maybe<Array<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'type' | 'name' | 'firstName' | 'lastName' | 'email' | 'department' | 'upn' | 'external' | 'companyName' | 'userType'>
    )>>, deputy: Types.Maybe<Array<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'type' | 'name' | 'firstName' | 'lastName' | 'email' | 'department' | 'upn' | 'external' | 'companyName' | 'userType'>
    )>>, hrgEditor: Types.Maybe<Array<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'type' | 'name' | 'firstName' | 'lastName' | 'email' | 'department' | 'upn' | 'external' | 'companyName' | 'userType'>
    )>>, orderIdDistribution: Types.Maybe<Array<(
      { __typename?: 'OrderIdDistribution' }
      & Pick<Types.OrderIdDistribution, '_id' | 'orderId' | 'percentage' | 'annotation'>
    )>>, participants: Types.Maybe<Array<(
      { __typename?: 'Participant' }
      & Pick<Types.Participant, '_id' | 'changeTimeStamp' | 'dateTo' | 'dateFrom' | 'note' | 'orderId' | 'percentage' | 'trackHotelRequired' | 'temporaryPass' | 'passActivation' | 'permanentDriveAuthorization' | 'singleDriveAuthorization' | 'dvEquipment' | 'partsTransport' | 'driverTraining' | 'nordschleife' | 'nordschleifeBookingStatus' | 'group'>
      & { _changes: Types.Maybe<{ __typename?: 'ProvingChangeTracking' }
        & ChangeTrackingFragmentFragment
      >, changedBy: Types.Maybe<(
        { __typename?: 'User' }
        & Pick<Types.User, '_id' | 'upn' | 'name' | 'type' | 'firstName' | 'lastName' | 'external' | 'companyName' | 'userType'>
      )>, person: Types.Maybe<(
        { __typename?: 'User' }
        & Pick<Types.User, 'department' | 'upn' | 'external' | 'roles' | 'companyName' | 'userType' | 'extension' | '_id' | 'type' | 'name' | 'firstName' | 'lastName' | 'email' | 'employeeId'>
      ) | (
        { __typename?: 'Worker' }
        & Pick<Types.Worker, 'company' | 'department' | 'annotation' | 'qBasic' | 'qTurbo' | 'qSupersport' | 'qNordschleife' | 'qMuLow' | 'qOffroad' | '_id' | 'type' | 'name' | 'firstName' | 'lastName' | 'email' | 'employeeId'>
      )>, headOfProving: Types.Maybe<(
        { __typename?: 'HeadOfProving' }
        & Pick<Types.HeadOfProving, 'isHeadOfProving' | 'dateFrom' | 'dateTo'>
      )>, unknownPerson: Types.Maybe<(
        { __typename?: 'UnknownPerson' }
        & Pick<Types.UnknownPerson, 'personType' | 'isUnknown' | 'department' | 'supplier' | 'employee' | 'firstName' | 'surName' | 'email'>
      )>, flight: Types.Maybe<(
        { __typename?: 'Flight' }
        & Pick<Types.Flight, 'flightType' | 'bookingStatus' | 'note'>
        & { returnData: Types.Maybe<(
          { __typename?: 'FlightMetadata' }
          & Pick<Types.FlightMetadata, 'airline' | 'flightNumber' | 'departure' | 'departureTime'>
        )>, outboundData: Types.Maybe<(
          { __typename?: 'FlightMetadata' }
          & Pick<Types.FlightMetadata, 'airline' | 'flightNumber' | 'departure' | 'departureTime'>
        )> }
      )>, accomodation: Types.Maybe<(
        { __typename?: 'Accomodation' }
        & Pick<Types.Accomodation, 'accomodationType' | 'note' | 'additionalAccomodation' | 'dateFrom' | 'dateTo' | 'bookingStatus'>
        & { accomodation: Types.Maybe<(
          { __typename?: 'Lodging' }
          & Pick<Types.Lodging, '_id' | 'title' | 'inactive' | 'land' | 'place' | 'address' | 'email' | 'emailHRG'>
        )> }
      )>, trackHotels: Types.Maybe<(
        { __typename?: 'TrackHotels' }
        & { outward: Types.Maybe<Array<(
          { __typename?: 'TrackHotel' }
          & Pick<Types.TrackHotel, '_id' | 'index' | 'dateFrom' | 'dateTo' | 'note' | 'bookingStatus'>
          & { hotel: Types.Maybe<(
            { __typename?: 'Lodging' }
            & Pick<Types.Lodging, '_id' | 'title' | 'address' | 'email' | 'emailHRG'>
          )> }
        )>>, return: Types.Maybe<Array<(
          { __typename?: 'TrackHotel' }
          & Pick<Types.TrackHotel, '_id' | 'index' | 'dateFrom' | 'dateTo' | 'note' | 'bookingStatus'>
          & { hotel: Types.Maybe<(
            { __typename?: 'Lodging' }
            & Pick<Types.Lodging, '_id' | 'title' | 'address' | 'email' | 'emailHRG'>
          )> }
        )>> }
      )>, rentalCar: Types.Maybe<(
        { __typename?: 'RentalCar' }
        & Pick<Types.RentalCar, 'carType' | 'dateTo' | 'dateFrom' | 'note' | 'bookingStatus'>
      )>, ferry: Types.Maybe<(
        { __typename?: 'Ferry' }
        & Pick<Types.Ferry, 'dateFrom' | 'timeFrom' | 'dateTo' | 'timeTo' | 'note' | 'bookingStatus'>
        & { outward: Types.Maybe<(
          { __typename?: 'FerryConnection' }
          & Pick<Types.FerryConnection, '_id' | 'title'>
        )>, return: Types.Maybe<(
          { __typename?: 'FerryConnection' }
          & Pick<Types.FerryConnection, '_id' | 'title'>
        )> }
      )>, forms: Types.Maybe<(
        { __typename?: 'Forms' }
        & { temporaryPass: Types.Maybe<(
          { __typename?: 'GeneratedDocument' }
          & Pick<Types.GeneratedDocument, 'uri' | 'name' | 'type'>
        )>, passActivation: Types.Maybe<(
          { __typename?: 'GeneratedDocument' }
          & Pick<Types.GeneratedDocument, 'uri' | 'name' | 'type'>
        )>, permanentDriveAuthorization: Types.Maybe<(
          { __typename?: 'GeneratedDocument' }
          & Pick<Types.GeneratedDocument, 'uri' | 'name' | 'type'>
        )>, singleDriveAuthorization: Types.Maybe<(
          { __typename?: 'GeneratedDocument' }
          & Pick<Types.GeneratedDocument, 'uri' | 'name' | 'type'>
        )>, dvEquipment: Types.Maybe<(
          { __typename?: 'GeneratedDocument' }
          & Pick<Types.GeneratedDocument, 'uri' | 'name' | 'type'>
        )>, partsTransport: Types.Maybe<(
          { __typename?: 'GeneratedDocument' }
          & Pick<Types.GeneratedDocument, 'uri' | 'name' | 'type'>
        )>, driverTraining: Types.Maybe<(
          { __typename?: 'GeneratedDocument' }
          & Pick<Types.GeneratedDocument, 'uri' | 'name' | 'type'>
        )> }
      )> }
    )>>, vehicles: Types.Maybe<Array<(
      { __typename?: 'InternalVehicle' }
      & Pick<Types.InternalVehicle, 'internalNumberUnknown' | 'label' | '_id' | 'type' | 'unknown' | 'dateTo' | 'dateFrom' | 'orderId' | 'model' | 'licensePlate' | 'licensePlateType' | 'vin' | 'exportedToSAP' | 'group'>
      & { _changes: Types.Maybe<{ __typename?: 'ProvingChangeTracking' }
        & ChangeTrackingFragmentFragment
      >, eqVehicle: Types.Maybe<(
        { __typename?: 'EQVehicle' }
        & Pick<Types.EqVehicle, '_id' | 'id' | 'internalLabel' | 'label' | 'licensePlate' | 'vin' | 'type' | 'typeDescription' | 'derivative'>
      )>, transport: Types.Maybe<(
        { __typename?: 'Transport' }
        & Pick<Types.Transport, 'transportType' | 'bookingStatus' | 'outboundTransportSenderTime' | 'outboundTransportSenderDate' | 'outboundTransportRecipientTime' | 'outboundTransportRecipientDate' | 'returnTransportSenderTime' | 'returnTransportSenderDate' | 'returnTransportRecipientTime' | 'returnTransportRecipientDate' | 'outboundTransportSenderContact' | 'outboundTransportRecipientContact' | 'returnTransportSenderContact' | 'returnTransportRecipientContact'>
        & { outboundTransportSender: Types.Maybe<{ __typename?: 'SenderRecipient' }
          & TransportFragmentFragment
        >, outboundTransportRecipient: Types.Maybe<{ __typename?: 'SenderRecipient' }
          & TransportFragmentFragment
        >, returnTransportSender: Types.Maybe<{ __typename?: 'SenderRecipient' }
          & TransportFragmentFragment
        >, returnTransportRecipient: Types.Maybe<{ __typename?: 'SenderRecipient' }
          & TransportFragmentFragment
        > }
      )> }
    ) | (
      { __typename?: 'ExternalVehicle' }
      & Pick<Types.ExternalVehicle, 'labelExternal' | '_id' | 'type' | 'unknown' | 'dateTo' | 'dateFrom' | 'orderId' | 'model' | 'licensePlate' | 'licensePlateType' | 'vin' | 'exportedToSAP' | 'group'>
      & { _changes: Types.Maybe<{ __typename?: 'ProvingChangeTracking' }
        & ChangeTrackingFragmentFragment
      >, transport: Types.Maybe<(
        { __typename?: 'Transport' }
        & Pick<Types.Transport, 'transportType' | 'bookingStatus' | 'outboundTransportSenderTime' | 'outboundTransportSenderDate' | 'outboundTransportRecipientTime' | 'outboundTransportRecipientDate' | 'returnTransportSenderTime' | 'returnTransportSenderDate' | 'returnTransportRecipientTime' | 'returnTransportRecipientDate' | 'outboundTransportSenderContact' | 'outboundTransportRecipientContact' | 'returnTransportSenderContact' | 'returnTransportRecipientContact'>
        & { outboundTransportSender: Types.Maybe<{ __typename?: 'SenderRecipient' }
          & TransportFragmentFragment
        >, outboundTransportRecipient: Types.Maybe<{ __typename?: 'SenderRecipient' }
          & TransportFragmentFragment
        >, returnTransportSender: Types.Maybe<{ __typename?: 'SenderRecipient' }
          & TransportFragmentFragment
        >, returnTransportRecipient: Types.Maybe<{ __typename?: 'SenderRecipient' }
          & TransportFragmentFragment
        > }
      )> }
    )>>, resourceRequirements: Types.Maybe<Array<(
      { __typename?: 'ResourceRequirement' }
      & Pick<Types.ResourceRequirement, '_id' | 'resourceRequirementType' | 'amount' | 'dateFrom' | 'dateTo' | 'racewayHours' | 'status'>
      & { testTrack: Types.Maybe<(
        { __typename?: 'TestTrack' }
        & Pick<Types.TestTrack, 'title'>
      )>, _changes: Types.Maybe<{ __typename?: 'ProvingChangeTracking' }
        & ChangeTrackingFragmentFragment
      >, testTrackUsage: Types.Maybe<(
        { __typename?: 'TestTrackUsage' }
        & Pick<Types.TestTrackUsage, '_id' | 'title'>
      )>, fuel: Types.Maybe<(
        { __typename?: 'Fuel' }
        & Pick<Types.Fuel, '_id' | 'title'>
      )>, chargingInfrastructure: Types.Maybe<(
        { __typename?: 'ChargingInfrastructure' }
        & Pick<Types.ChargingInfrastructure, '_id' | 'title'>
      )>, orderIdDistribution: Types.Maybe<Array<(
        { __typename?: 'OrderIdDistribution' }
        & Pick<Types.OrderIdDistribution, '_id' | 'orderId' | 'percentage' | 'annotation'>
      )>> }
    )>>, nmf: Types.Maybe<(
      { __typename?: 'Nmf' }
      & Pick<Types.Nmf, 'requirement' | 'release' | 'transport' | 'informed'>
    )>, specialUsage: Types.Maybe<(
      { __typename?: 'SpecialUsage' }
      & Pick<Types.SpecialUsage, 'bySaturday' | 'bySunday' | 'byNight'>
    )>, internalMemo: Types.Maybe<(
      { __typename?: 'InternalMemo' }
      & Pick<Types.InternalMemo, 'state' | 'sentOn'>
      & { mailingList: Types.Maybe<Array<(
        { __typename?: 'User' }
        & Pick<Types.User, '_id' | 'type' | 'name' | 'firstName' | 'lastName' | 'email' | 'department' | 'upn' | 'external' | 'roles'>
      )>>, memo: Types.Maybe<(
        { __typename?: 'GeneratedDocument' }
        & Pick<Types.GeneratedDocument, 'uri' | 'name' | 'type'>
      )>, testRecipient: Types.Maybe<(
        { __typename?: 'User' }
        & Pick<Types.User, '_id' | 'type' | 'name' | 'firstName' | 'lastName' | 'email' | 'department' | 'upn' | 'external' | 'roles'>
      )> }
    )>, arrivalSheet: Types.Maybe<(
      { __typename?: 'GeneratedDocument' }
      & Pick<Types.GeneratedDocument, 'uri' | 'name' | 'type'>
    )>, applicationForm: Types.Maybe<(
      { __typename?: 'GeneratedDocument' }
      & Pick<Types.GeneratedDocument, 'uri' | 'name' | 'type'>
    )>, resourceBookings: Types.Maybe<Array<(
      { __typename?: 'ResourceBooking' }
      & Pick<Types.ResourceBooking, '_id' | 'participantId' | 'dateFrom' | 'dateTo' | 'orderId' | 'status' | 'usageTime'>
      & { _changes: Types.Maybe<{ __typename?: 'ProvingChangeTracking' }
        & ChangeTrackingFragmentFragment
      >, resource: (
        { __typename?: 'Resource' }
        & Pick<Types.Resource, '_id' | 'type' | 'category' | 'title' | 'parentId' | 'inactive' | 'costPerUnit' | 'notification' | 'external'>
        & { usageTimespans: Types.Maybe<Array<(
          { __typename?: 'UsageTimeSpan' }
          & Pick<Types.UsageTimeSpan, 'dateFrom' | 'dateTo'>
        )>>, parent: Types.Maybe<(
          { __typename?: 'Resource' }
          & Pick<Types.Resource, '_id' | 'rootId' | 'title' | 'category' | 'type'>
          & { parent: Types.Maybe<(
            { __typename?: 'Resource' }
            & Pick<Types.Resource, '_id' | 'rootId' | 'title' | 'category' | 'type'>
            & { parent: Types.Maybe<(
              { __typename?: 'Resource' }
              & Pick<Types.Resource, '_id' | 'rootId' | 'title' | 'category' | 'type'>
              & { parent: Types.Maybe<(
                { __typename?: 'Resource' }
                & Pick<Types.Resource, '_id' | 'rootId' | 'title' | 'category' | 'type'>
                & { parent: Types.Maybe<(
                  { __typename?: 'Resource' }
                  & Pick<Types.Resource, '_id' | 'rootId' | 'title' | 'category' | 'type'>
                )> }
              )> }
            )> }
          )> }
        )> }
      ) }
    )>>, materials: Types.Maybe<Array<(
      { __typename?: 'ProvingMaterial' }
      & Pick<Types.ProvingMaterial, '_id' | 'dateFrom' | 'dateTo' | 'amount' | 'outboundExportedToSAP' | 'returnExportedToSAP' | 'orderId' | 'annotation' | 'group' | 'isDangerousGood'>
      & { _changes: Types.Maybe<{ __typename?: 'ProvingChangeTracking' }
        & ChangeTrackingFragmentFragment
      >, material: (
        { __typename?: 'Material' }
        & Pick<Types.Material, '_id' | 'containerType' | 'label' | 'nettoWeight' | 'length' | 'width' | 'height'>
      ), transport: Types.Maybe<(
        { __typename?: 'Transport' }
        & Pick<Types.Transport, 'transportType' | 'bookingStatus' | 'outboundTransportSenderTime' | 'outboundTransportSenderDate' | 'outboundTransportRecipientTime' | 'outboundTransportRecipientDate' | 'returnTransportSenderTime' | 'returnTransportSenderDate' | 'returnTransportRecipientTime' | 'returnTransportRecipientDate'>
        & { outboundTransportSender: Types.Maybe<{ __typename?: 'SenderRecipient' }
          & TransportFragmentFragment
        >, outboundTransportRecipient: Types.Maybe<{ __typename?: 'SenderRecipient' }
          & TransportFragmentFragment
        >, returnTransportSender: Types.Maybe<{ __typename?: 'SenderRecipient' }
          & TransportFragmentFragment
        >, returnTransportRecipient: Types.Maybe<{ __typename?: 'SenderRecipient' }
          & TransportFragmentFragment
        > }
      )>, dangerousGood: Types.Maybe<(
        { __typename?: 'DangerousGood' }
        & Pick<Types.DangerousGood, 'unNumber' | 'description'>
      )> }
    )>>, mailTemplates: Types.Maybe<Array<(
      { __typename?: 'MailTemplate' }
      & Pick<Types.MailTemplate, '_id' | 'name' | 'type' | 'inactive'>
    )>>, pendingChanges: Types.Maybe<Array<(
      { __typename?: 'ProvingChange' }
      & Pick<Types.ProvingChange, '_id' | 'status' | 'provingId' | 'created'>
      & { createdBy: (
        { __typename?: 'User' }
        & Pick<Types.User, '_id' | 'upn' | 'external' | 'name' | 'type' | 'firstName' | 'lastName' | 'companyName' | 'userType'>
      ), change: (
        { __typename?: 'ProvingChangeDetails' }
        & Pick<Types.ProvingChangeDetails, 'key' | 'type' | 'path' | 'value' | 'oldValue'>
      ) }
    )>>, authorization: Types.Maybe<(
      { __typename?: 'ProvingAuthorization' }
      & Pick<Types.ProvingAuthorization, 'role' | 'permissions'>
    )>, supportNeeds: Types.Maybe<(
      { __typename?: 'SupportNeeds' }
      & Pick<Types.SupportNeeds, 'ewg' | 'ewi' | 'evd' | 'hv' | 'noSupport'>
    )>, materialsTransport: Types.Maybe<(
      { __typename?: 'MaterialsTransport' }
      & Pick<Types.MaterialsTransport, 'transportType' | 'outboundTransportSenderTime' | 'outboundTransportSenderDate' | 'outboundTransportRecipientTime' | 'outboundTransportRecipientDate' | 'returnTransportSenderTime' | 'returnTransportSenderDate' | 'returnTransportRecipientTime' | 'returnTransportRecipientDate'>
      & { outboundTransportSender: Types.Maybe<{ __typename?: 'SenderRecipient' }
        & TransportFragmentFragment
      >, outboundTransportRecipient: Types.Maybe<{ __typename?: 'SenderRecipient' }
        & TransportFragmentFragment
      >, returnTransportSender: Types.Maybe<{ __typename?: 'SenderRecipient' }
        & TransportFragmentFragment
      >, returnTransportRecipient: Types.Maybe<{ __typename?: 'SenderRecipient' }
        & TransportFragmentFragment
      > }
    )> }
  )> }
);

export type ProvingsQueryVariables = {};


export type ProvingsQuery = (
  { __typename?: 'Query' }
  & { provings: Array<(
    { __typename?: 'Proving' }
    & Pick<Types.Proving, '_id' | 'id'>
    & { provingGround: Types.Maybe<(
      { __typename?: 'ProvingGround' }
      & Pick<Types.ProvingGround, '_id' | 'title'>
    )>, participants: Types.Maybe<Array<(
      { __typename?: 'Participant' }
      & Pick<Types.Participant, 'dateFrom' | 'dateTo'>
      & { person: Types.Maybe<(
        { __typename?: 'User' }
        & Pick<Types.User, '_id'>
      ) | (
        { __typename?: 'Worker' }
        & Pick<Types.Worker, '_id'>
      )> }
    )>>, resourceBookings: Types.Maybe<Array<(
      { __typename?: 'ResourceBooking' }
      & Pick<Types.ResourceBooking, '_id' | 'dateFrom' | 'dateTo' | 'orderId' | 'status' | 'usageTime' | 'participantId'>
      & { resource: (
        { __typename?: 'Resource' }
        & Pick<Types.Resource, '_id' | 'type' | 'legacyType' | 'category' | 'title' | 'inactive' | 'rootId' | 'abbr' | 'annotation' | 'unit' | 'costPerUnit' | 'color' | 'parentId'>
        & { parent: Types.Maybe<(
          { __typename?: 'Resource' }
          & Pick<Types.Resource, '_id' | 'type' | 'category' | 'legacyType' | 'title'>
        )> }
      ) }
    )>>, vehicles: Types.Maybe<Array<(
      { __typename?: 'InternalVehicle' }
      & Pick<Types.InternalVehicle, 'dateFrom' | 'dateTo'>
      & { eqVehicle: Types.Maybe<(
        { __typename?: 'EQVehicle' }
        & Pick<Types.EqVehicle, '_id' | 'id'>
      )> }
    ) | (
      { __typename?: 'ExternalVehicle' }
      & Pick<Types.ExternalVehicle, 'dateFrom' | 'dateTo'>
    )>> }
  )> }
);

export type UpdateProvingMutationVariables = {
  id: Types.Scalars['String'],
  update: Types.ProvingUpdateType
};


export type UpdateProvingMutation = (
  { __typename?: 'Mutation' }
  & { updateProving: (
    { __typename?: 'Proving' }
    & Pick<Types.Proving, '_id' | 'id' | 'title'>
  ) }
);

export type UpdateProvingStatusMutationVariables = {
  id: Types.Scalars['String'],
  status: Types.Scalars['Int'],
  declineReason?: Types.Maybe<Types.Scalars['String']>,
  editor?: Types.Maybe<Array<Types.Maybe<Types.Scalars['ObjectId']>>>
};


export type UpdateProvingStatusMutation = (
  { __typename?: 'Mutation' }
  & { updateProvingStatus: (
    { __typename?: 'Proving' }
    & Pick<Types.Proving, '_id' | 'id' | 'status'>
  ) }
);

export type DoubleBookingsParticipantsListQueryVariables = {};


export type DoubleBookingsParticipantsListQuery = (
  { __typename?: 'Query' }
  & { cachedProvings: Array<(
    { __typename?: 'Proving' }
    & { participants: Types.Maybe<Array<(
      { __typename?: 'Participant' }
      & Pick<Types.Participant, '_id' | 'dateTo' | 'dateFrom'>
      & { person: Types.Maybe<(
        { __typename?: 'User' }
        & Pick<Types.User, '_id'>
      ) | (
        { __typename?: 'Worker' }
        & Pick<Types.Worker, '_id'>
      )> }
    )>> }
  )> }
);

export type DoubleBookingsParticipantsQueryVariables = {};


export type DoubleBookingsParticipantsQuery = (
  { __typename?: 'Query' }
  & { cachedProvings: Array<(
    { __typename?: 'Proving' }
    & Pick<Types.Proving, '_id' | 'id' | 'title' | 'department'>
    & { participants: Types.Maybe<Array<(
      { __typename?: 'Participant' }
      & Pick<Types.Participant, '_id' | 'dateTo' | 'dateFrom'>
      & { person: Types.Maybe<(
        { __typename?: 'User' }
        & Pick<Types.User, 'department' | 'upn' | 'external' | 'roles' | 'extension' | '_id' | 'type' | 'name' | 'firstName' | 'lastName' | 'email'>
      ) | (
        { __typename?: 'Worker' }
        & Pick<Types.Worker, 'department' | '_id' | 'type' | 'name' | 'firstName' | 'lastName' | 'email'>
      )> }
    )>>, provingGround: Types.Maybe<(
      { __typename?: 'ProvingGround' }
      & Pick<Types.ProvingGround, '_id' | 'title'>
    )> }
  )> }
);

export type DoubleBookingsVehiclesListQueryVariables = {};


export type DoubleBookingsVehiclesListQuery = (
  { __typename?: 'Query' }
  & { cachedProvings: Array<(
    { __typename?: 'Proving' }
    & { vehicles: Types.Maybe<Array<(
      { __typename?: 'InternalVehicle' }
      & Pick<Types.InternalVehicle, 'dateFrom' | 'dateTo'>
      & { eqVehicle: Types.Maybe<(
        { __typename?: 'EQVehicle' }
        & Pick<Types.EqVehicle, 'id'>
      )> }
    ) | (
      { __typename?: 'ExternalVehicle' }
      & Pick<Types.ExternalVehicle, 'dateFrom' | 'dateTo'>
    )>> }
  )> }
);

export type DoubleBookingsVehiclesQueryVariables = {};


export type DoubleBookingsVehiclesQuery = (
  { __typename?: 'Query' }
  & { cachedProvings: Array<(
    { __typename?: 'Proving' }
    & Pick<Types.Proving, '_id' | 'id' | 'title'>
    & { vehicles: Types.Maybe<Array<(
      { __typename?: 'InternalVehicle' }
      & Pick<Types.InternalVehicle, 'internalNumberUnknown' | 'label' | '_id' | 'dateFrom' | 'dateTo'>
      & { eqVehicle: Types.Maybe<(
        { __typename?: 'EQVehicle' }
        & Pick<Types.EqVehicle, '_id' | 'id' | 'label'>
      )> }
    ) | (
      { __typename?: 'ExternalVehicle' }
      & Pick<Types.ExternalVehicle, '_id' | 'dateFrom' | 'dateTo'>
    )>>, provingGround: Types.Maybe<(
      { __typename?: 'ProvingGround' }
      & Pick<Types.ProvingGround, '_id' | 'title'>
    )> }
  )> }
);

export type DoubleBookingsResourceBookingsListQueryVariables = {};


export type DoubleBookingsResourceBookingsListQuery = (
  { __typename?: 'Query' }
  & { cachedProvings: Array<(
    { __typename?: 'Proving' }
    & Pick<Types.Proving, '_id'>
    & { resourceBookings: Types.Maybe<Array<(
      { __typename?: 'ResourceBooking' }
      & Pick<Types.ResourceBooking, 'dateFrom' | 'dateTo'>
      & { resource: (
        { __typename?: 'Resource' }
        & Pick<Types.Resource, '_id'>
      ) }
    )>> }
  )> }
);

export type DoubleBookingsResourceBookingsQueryVariables = {};


export type DoubleBookingsResourceBookingsQuery = (
  { __typename?: 'Query' }
  & { cachedProvings: Array<(
    { __typename?: 'Proving' }
    & Pick<Types.Proving, '_id' | 'id' | 'department'>
    & { resourceBookings: Types.Maybe<Array<(
      { __typename?: 'ResourceBooking' }
      & Pick<Types.ResourceBooking, 'dateFrom' | 'dateTo'>
      & { resource: (
        { __typename?: 'Resource' }
        & Pick<Types.Resource, '_id' | 'title'>
      ) }
    )>>, provingGround: Types.Maybe<(
      { __typename?: 'ProvingGround' }
      & Pick<Types.ProvingGround, '_id' | 'title'>
    )> }
  )> }
);

export type GenerateExcelOerviewMutationVariables = {
  id: Types.Scalars['String']
};


export type GenerateExcelOerviewMutation = (
  { __typename?: 'Mutation' }
  & Pick<Types.Mutation, 'excelOverview'>
);

export type AcceptedProvingChangesQueryVariables = {
  id: Types.Scalars['String']
};


export type AcceptedProvingChangesQuery = (
  { __typename?: 'Query' }
  & { acceptedProvingChanges: Array<(
    { __typename?: 'ProvingChange' }
    & Pick<Types.ProvingChange, '_id' | 'provingId' | 'status' | 'created' | 'resolved'>
    & { change: (
      { __typename?: 'ProvingChangeDetails' }
      & Pick<Types.ProvingChangeDetails, 'key' | 'type' | 'path' | 'value' | 'valueType' | 'oldValue' | 'relativePath'>
    ), createdBy: (
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'type' | 'upn' | 'firstName' | 'lastName' | 'name' | 'email' | 'department' | 'employeeId'>
    ), resolvedBy: Types.Maybe<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'type' | 'upn' | 'firstName' | 'lastName' | 'name' | 'email' | 'department' | 'employeeId'>
    )> }
  )> }
);

export const ProvingDocument = gql`
    query Proving($id: ID!) {
  proving(id: $id) {
    _id
    _snapshotTimestamp
    _changes {
      ...ChangeTrackingFragment
    }
    deletionPeriod
    deletionRule
    documents {
      _id
      uri
      name
      block
      participantId
      type
    }
    id
    type
    title
    maintenanceHead {
      _id
      type
      name
      firstName
      lastName
      email
      department
      upn
      external
      companyName
      userType
    }
    declined
    declinedBy {
      _id
      type
      name
      firstName
      lastName
      email
      department
      upn
      external
      companyName
      userType
    }
    created
    createdBy {
      _id
      type
      name
      firstName
      lastName
      email
      department
      upn
      external
      companyName
      userType
    }
    modified
    modifiedBy {
      _id
      type
      name
      firstName
      lastName
      email
      department
      upn
      external
      companyName
      userType
    }
    statusChange {
      _id
      provingId
      status
      change {
        oldValue
        key
        type
        path
        valueType
      }
      created
      createdBy {
        _id
        upn
        name
        type
        firstName
        lastName
        external
        companyName
        userType
      }
      resolved
      resolvedBy {
        _id
        upn
        name
        type
        firstName
        lastName
        external
        companyName
        userType
      }
    }
    dateFrom
    dateTo
    description
    declineReason
    status
    provingGround {
      _id
      title
      countryCode
      abbr
      specialNote
      inactive
      noteHeaderVehicles
      noteVehicles
      noteHeaderMaterials
      noteMaterials
      hideFlight
      hideFerryConnection
      hideNordschleife
      hideHotels
      skipClearing
      useUsageTimespansOnly
      drivingLessons
      vehicleTransportToDays
      vehicleTransportFromDays
      outboundTransportSender {
        ...TransportFragment
      }
      outboundTransportRecipient {
        ...TransportFragment
      }
      returnTransportSender {
        ...TransportFragment
      }
      returnTransportRecipient {
        ...TransportFragment
      }
      racewayHours
      showNMF
      showSpecialUsage
      deleteEditor
      fileTemplates {
        _id
        fileName
        uri
        type
        cellMapping
        provingGround {
          _id
        }
      }
      editors {
        _id
        type
        name
        firstName
        lastName
        email
        department
        upn
        external
        companyName
        userType
      }
      clearing {
        _id
        type
        name
        firstName
        lastName
        email
        department
        upn
        external
        companyName
        userType
      }
      resourceManagers {
        _id
        type
        name
        firstName
        lastName
        email
        department
        upn
        external
        companyName
        userType
      }
      authorizedEditors {
        _id
        type
        name
        firstName
        lastName
        email
        department
        upn
        external
        companyName
        userType
      }
      block1
      block2
      block3
      block4
      block5
      block6
      block7
      block8
      block9
      block10
      block1Note
      block2Note
      block3Note
      block4Note
      block5Note
      block6Note
      block7Note
      block8Note
      block9Note
      block10Note
      block1Files
      block2Files
      block3Files
      block4Files
      block5Files
      block6Files
      block7Files
      block8Files
      block9Files
      block10Files
      fixedRates {
        ...FixedRatesFragment
      }
    }
    department
    leadingDepartment
    costCentre
    sumOfCosts
    effectiveSumOfCosts
    newMails
    responsible {
      _id
      type
      name
      firstName
      lastName
      email
      department
      upn
      external
      companyName
      userType
    }
    editor {
      _id
      type
      name
      firstName
      lastName
      email
      department
      upn
      external
      companyName
      userType
    }
    resourceManager {
      _id
      type
      name
      firstName
      lastName
      email
      department
      upn
      external
      companyName
      userType
    }
    deputy {
      _id
      type
      name
      firstName
      lastName
      email
      department
      upn
      external
      companyName
      userType
    }
    hrgEditor {
      _id
      type
      name
      firstName
      lastName
      email
      department
      upn
      external
      companyName
      userType
    }
    orderIdDistribution {
      _id
      orderId
      percentage
      annotation
    }
    participants {
      _id
      _changes {
        ...ChangeTrackingFragment
      }
      changedBy {
        _id
        upn
        name
        type
        firstName
        lastName
        external
        companyName
        userType
      }
      changeTimeStamp
      dateTo
      dateFrom
      note
      person {
        _id
        type
        name
        firstName
        lastName
        email
        employeeId
        department
        ... on Worker {
          company
          department
          annotation
          qBasic
          qTurbo
          qSupersport
          qNordschleife
          qMuLow
          qOffroad
        }
        ... on User {
          department
          upn
          external
          roles
          companyName
          userType
          extension
        }
      }
      headOfProving {
        isHeadOfProving
        dateFrom
        dateTo
      }
      unknownPerson {
        personType
        isUnknown
        department
        supplier
        employee
        firstName
        surName
        email
      }
      orderId
      flight {
        flightType
        bookingStatus
        note
        returnData {
          airline
          flightNumber
          departure
          departureTime
        }
        outboundData {
          airline
          flightNumber
          departure
          departureTime
        }
      }
      percentage
      accomodation {
        accomodationType
        note
        additionalAccomodation
        accomodation {
          _id
          title
          inactive
          land
          place
          address
          email
          emailHRG
        }
        dateFrom
        dateTo
        bookingStatus
      }
      trackHotelRequired
      trackHotels {
        outward {
          _id
          index
          dateFrom
          dateTo
          hotel {
            _id
            title
            address
            email
            emailHRG
          }
          note
          bookingStatus
        }
        return {
          _id
          index
          dateFrom
          dateTo
          hotel {
            _id
            title
            address
            email
            emailHRG
          }
          note
          bookingStatus
        }
      }
      rentalCar {
        carType
        dateTo
        dateFrom
        note
        bookingStatus
      }
      temporaryPass
      passActivation
      permanentDriveAuthorization
      singleDriveAuthorization
      dvEquipment
      partsTransport
      driverTraining
      ferry {
        outward {
          _id
          title
        }
        return {
          _id
          title
        }
        dateFrom
        timeFrom
        dateTo
        timeTo
        note
        bookingStatus
      }
      nordschleife
      nordschleifeBookingStatus
      group
      forms {
        temporaryPass {
          uri
          name
          type
        }
        passActivation {
          uri
          name
          type
        }
        permanentDriveAuthorization {
          uri
          name
          type
        }
        singleDriveAuthorization {
          uri
          name
          type
        }
        dvEquipment {
          uri
          name
          type
        }
        partsTransport {
          uri
          name
          type
        }
        driverTraining {
          uri
          name
          type
        }
      }
    }
    vehicles {
      _id
      ... on InternalVehicle {
        _changes {
          ...ChangeTrackingFragment
        }
      }
      ... on ExternalVehicle {
        _changes {
          ...ChangeTrackingFragment
        }
      }
      type
      unknown
      dateTo
      dateFrom
      orderId
      transport {
        transportType
        bookingStatus
        outboundTransportSender {
          ...TransportFragment
        }
        outboundTransportSenderTime
        outboundTransportSenderDate
        outboundTransportRecipient {
          ...TransportFragment
        }
        outboundTransportRecipientTime
        outboundTransportRecipientDate
        returnTransportSender {
          ...TransportFragment
        }
        returnTransportSenderTime
        returnTransportSenderDate
        returnTransportRecipient {
          ...TransportFragment
        }
        returnTransportRecipientTime
        returnTransportRecipientDate
        outboundTransportSenderContact
        outboundTransportRecipientContact
        returnTransportSenderContact
        returnTransportRecipientContact
      }
      model
      licensePlate
      licensePlateType
      vin
      ... on InternalVehicle {
        internalNumberUnknown
        eqVehicle {
          _id
          id
          internalLabel
          label
          licensePlate
          vin
          type
          typeDescription
          derivative
        }
        label
      }
      ... on ExternalVehicle {
        labelExternal
      }
      exportedToSAP
      group
    }
    resourceRequirements {
      _id
      resourceRequirementType
      testTrack {
        title
      }
      _changes {
        ...ChangeTrackingFragment
      }
      testTrackUsage {
        _id
        title
      }
      fuel {
        _id
        title
      }
      chargingInfrastructure {
        _id
        title
      }
      amount
      dateFrom
      dateTo
      racewayHours
      orderIdDistribution {
        _id
        orderId
        percentage
        annotation
      }
      status
    }
    nmf {
      requirement
      release
      transport
      informed
    }
    specialUsage {
      bySaturday
      bySunday
      byNight
    }
    internalMemo {
      mailingList {
        _id
        type
        name
        firstName
        lastName
        email
        department
        upn
        external
        roles
      }
      memo {
        uri
        name
        type
      }
      testRecipient {
        _id
        type
        name
        firstName
        lastName
        email
        department
        upn
        external
        roles
      }
      state
      sentOn
    }
    arrivalSheet {
      uri
      name
      type
    }
    applicationForm {
      uri
      name
      type
    }
    resourceBookings {
      _id
      participantId
      _changes {
        ...ChangeTrackingFragment
      }
      resource {
        _id
        type
        category
        title
        parentId
        inactive
        costPerUnit
        notification
        external
        usageTimespans {
          dateFrom
          dateTo
        }
        parent {
          _id
          rootId
          title
          category
          type
          parent {
            _id
            rootId
            title
            category
            type
            parent {
              _id
              rootId
              title
              category
              type
              parent {
                _id
                rootId
                title
                category
                type
                parent {
                  _id
                  rootId
                  title
                  category
                  type
                }
              }
            }
          }
        }
      }
      dateFrom
      dateTo
      orderId
      status
      usageTime
    }
    materials {
      _id
      _changes {
        ...ChangeTrackingFragment
      }
      material {
        _id
        containerType
        label
        nettoWeight
        length
        width
        height
      }
      dateFrom
      dateTo
      amount
      transport {
        transportType
        bookingStatus
        outboundTransportSender {
          ...TransportFragment
        }
        outboundTransportSenderTime
        outboundTransportSenderDate
        outboundTransportRecipient {
          ...TransportFragment
        }
        outboundTransportRecipientTime
        outboundTransportRecipientDate
        returnTransportSender {
          ...TransportFragment
        }
        returnTransportSenderTime
        returnTransportSenderDate
        returnTransportRecipient {
          ...TransportFragment
        }
        returnTransportRecipientTime
        returnTransportRecipientDate
      }
      outboundExportedToSAP
      returnExportedToSAP
      orderId
      annotation
      group
      isDangerousGood
      dangerousGood {
        unNumber
        description
      }
    }
    mailTemplates {
      _id
      name
      type
      inactive
    }
    pendingChanges {
      _id
      status
      provingId
      created
      createdBy {
        _id
        upn
        external
        name
        type
        firstName
        lastName
        companyName
        userType
      }
      change {
        key
        type
        path
        value
        oldValue
      }
    }
    authorization {
      role
      permissions
    }
    dvtWvtCheckDisabled
    headOfProvingCheckDisabled
    multiSelectEditorCheckEnabled
    serviceTeamIsEditing
    hrgIsEditing
    multiSelectResponsibleCheckEnabled
    multiSelectSubstituteCheckEnabled
    adminsOnlyResponsibleCheckEnabled
    adminsOnlySubstituteCheckEnabled
    enableGroups
    hasIncompleteBookings
    annotationParticipants
    annotationVehicles
    annotationResourceRequirements
    annotationResourceBookings
    annotationForms
    annotationMaterials
    annotationFiles
    supportNeeds {
      ewg
      ewi
      evd
      hv
      noSupport
    }
    materialsTransport {
      transportType
      outboundTransportSender {
        ...TransportFragment
      }
      outboundTransportSenderTime
      outboundTransportSenderDate
      outboundTransportRecipient {
        ...TransportFragment
      }
      outboundTransportRecipientTime
      outboundTransportRecipientDate
      returnTransportSender {
        ...TransportFragment
      }
      returnTransportSenderTime
      returnTransportSenderDate
      returnTransportRecipient {
        ...TransportFragment
      }
      returnTransportRecipientTime
      returnTransportRecipientDate
    }
    materialsExportedToSAP
  }
}
    ${ChangeTrackingFragmentFragmentDoc}
${TransportFragmentFragmentDoc}
${FixedRatesFragmentFragmentDoc}`;

    export function useProvingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProvingQuery, ProvingQueryVariables>) {
      return ApolloReactHooks.useQuery<ProvingQuery, ProvingQueryVariables>(ProvingDocument, baseOptions);
    };
      export function useProvingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProvingQuery, ProvingQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<ProvingQuery, ProvingQueryVariables>(ProvingDocument, baseOptions);
      };
      
export type ProvingQueryHookResult = ReturnType<typeof useProvingQuery>;
export type ProvingQueryResult = ApolloReactCommon.QueryResult<ProvingQuery, ProvingQueryVariables>;
export const ProvingsDocument = gql`
    query Provings {
  provings(filter: {status: {NIN: [8, 9, 10]}}) {
    _id
    id
    provingGround {
      _id
      title
    }
    participants {
      person {
        _id
      }
      dateFrom
      dateTo
    }
    resourceBookings {
      _id
      resource {
        _id
        type
        legacyType
        category
        title
        inactive
        rootId
        abbr
        annotation
        unit
        costPerUnit
        color
        parentId
        parent {
          _id
          type
          category
          legacyType
          title
        }
      }
      dateFrom
      dateTo
      orderId
      status
      usageTime
      participantId
    }
    vehicles {
      dateFrom
      dateTo
      ... on InternalVehicle {
        eqVehicle {
          _id
          id
        }
      }
    }
  }
}
    `;

    export function useProvingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProvingsQuery, ProvingsQueryVariables>) {
      return ApolloReactHooks.useQuery<ProvingsQuery, ProvingsQueryVariables>(ProvingsDocument, baseOptions);
    };
      export function useProvingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProvingsQuery, ProvingsQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<ProvingsQuery, ProvingsQueryVariables>(ProvingsDocument, baseOptions);
      };
      
export type ProvingsQueryHookResult = ReturnType<typeof useProvingsQuery>;
export type ProvingsQueryResult = ApolloReactCommon.QueryResult<ProvingsQuery, ProvingsQueryVariables>;
export const UpdateProvingDocument = gql`
    mutation UpdateProving($id: String!, $update: ProvingUpdateType!) {
  updateProving(id: $id, update: $update) {
    _id
    id
    title
  }
}
    `;
export type UpdateProvingMutationFn = ApolloReactCommon.MutationFunction<UpdateProvingMutation, UpdateProvingMutationVariables>;

    export function useUpdateProvingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProvingMutation, UpdateProvingMutationVariables>) {
      return ApolloReactHooks.useMutation<UpdateProvingMutation, UpdateProvingMutationVariables>(UpdateProvingDocument, baseOptions);
    };
export type UpdateProvingMutationHookResult = ReturnType<typeof useUpdateProvingMutation>;
export type UpdateProvingMutationResult = ApolloReactCommon.MutationResult<UpdateProvingMutation>;
export type UpdateProvingMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateProvingMutation, UpdateProvingMutationVariables>;
export const UpdateProvingStatusDocument = gql`
    mutation UpdateProvingStatus($id: String!, $status: Int!, $declineReason: String, $editor: [ObjectId]) {
  updateProvingStatus(id: $id, status: $status, declineReason: $declineReason, editor: $editor) {
    _id
    id
    status
  }
}
    `;
export type UpdateProvingStatusMutationFn = ApolloReactCommon.MutationFunction<UpdateProvingStatusMutation, UpdateProvingStatusMutationVariables>;

    export function useUpdateProvingStatusMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProvingStatusMutation, UpdateProvingStatusMutationVariables>) {
      return ApolloReactHooks.useMutation<UpdateProvingStatusMutation, UpdateProvingStatusMutationVariables>(UpdateProvingStatusDocument, baseOptions);
    };
export type UpdateProvingStatusMutationHookResult = ReturnType<typeof useUpdateProvingStatusMutation>;
export type UpdateProvingStatusMutationResult = ApolloReactCommon.MutationResult<UpdateProvingStatusMutation>;
export type UpdateProvingStatusMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateProvingStatusMutation, UpdateProvingStatusMutationVariables>;
export const DoubleBookingsParticipantsListDocument = gql`
    query DoubleBookingsParticipantsList {
  cachedProvings(filter: {status: {NIN: [8, 9, 10]}}) {
    participants {
      _id
      dateTo
      dateFrom
      person {
        _id
      }
    }
  }
}
    `;

    export function useDoubleBookingsParticipantsListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DoubleBookingsParticipantsListQuery, DoubleBookingsParticipantsListQueryVariables>) {
      return ApolloReactHooks.useQuery<DoubleBookingsParticipantsListQuery, DoubleBookingsParticipantsListQueryVariables>(DoubleBookingsParticipantsListDocument, baseOptions);
    };
      export function useDoubleBookingsParticipantsListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DoubleBookingsParticipantsListQuery, DoubleBookingsParticipantsListQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<DoubleBookingsParticipantsListQuery, DoubleBookingsParticipantsListQueryVariables>(DoubleBookingsParticipantsListDocument, baseOptions);
      };
      
export type DoubleBookingsParticipantsListQueryHookResult = ReturnType<typeof useDoubleBookingsParticipantsListQuery>;
export type DoubleBookingsParticipantsListQueryResult = ApolloReactCommon.QueryResult<DoubleBookingsParticipantsListQuery, DoubleBookingsParticipantsListQueryVariables>;
export const DoubleBookingsParticipantsDocument = gql`
    query DoubleBookingsParticipants {
  cachedProvings(filter: {status: {NIN: [8, 9, 10]}}) {
    _id
    id
    title
    department
    participants {
      _id
      dateTo
      dateFrom
      person {
        _id
        type
        name
        firstName
        lastName
        email
        ... on Worker {
          department
        }
        ... on User {
          department
          upn
          external
          roles
          extension
        }
      }
    }
    provingGround {
      _id
      title
    }
  }
}
    `;

    export function useDoubleBookingsParticipantsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DoubleBookingsParticipantsQuery, DoubleBookingsParticipantsQueryVariables>) {
      return ApolloReactHooks.useQuery<DoubleBookingsParticipantsQuery, DoubleBookingsParticipantsQueryVariables>(DoubleBookingsParticipantsDocument, baseOptions);
    };
      export function useDoubleBookingsParticipantsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DoubleBookingsParticipantsQuery, DoubleBookingsParticipantsQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<DoubleBookingsParticipantsQuery, DoubleBookingsParticipantsQueryVariables>(DoubleBookingsParticipantsDocument, baseOptions);
      };
      
export type DoubleBookingsParticipantsQueryHookResult = ReturnType<typeof useDoubleBookingsParticipantsQuery>;
export type DoubleBookingsParticipantsQueryResult = ApolloReactCommon.QueryResult<DoubleBookingsParticipantsQuery, DoubleBookingsParticipantsQueryVariables>;
export const DoubleBookingsVehiclesListDocument = gql`
    query DoubleBookingsVehiclesList {
  cachedProvings(filter: {status: {NIN: [8, 9, 10]}}) {
    vehicles {
      dateFrom
      dateTo
      ... on InternalVehicle {
        eqVehicle {
          id
        }
      }
    }
  }
}
    `;

    export function useDoubleBookingsVehiclesListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DoubleBookingsVehiclesListQuery, DoubleBookingsVehiclesListQueryVariables>) {
      return ApolloReactHooks.useQuery<DoubleBookingsVehiclesListQuery, DoubleBookingsVehiclesListQueryVariables>(DoubleBookingsVehiclesListDocument, baseOptions);
    };
      export function useDoubleBookingsVehiclesListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DoubleBookingsVehiclesListQuery, DoubleBookingsVehiclesListQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<DoubleBookingsVehiclesListQuery, DoubleBookingsVehiclesListQueryVariables>(DoubleBookingsVehiclesListDocument, baseOptions);
      };
      
export type DoubleBookingsVehiclesListQueryHookResult = ReturnType<typeof useDoubleBookingsVehiclesListQuery>;
export type DoubleBookingsVehiclesListQueryResult = ApolloReactCommon.QueryResult<DoubleBookingsVehiclesListQuery, DoubleBookingsVehiclesListQueryVariables>;
export const DoubleBookingsVehiclesDocument = gql`
    query DoubleBookingsVehicles {
  cachedProvings(filter: {status: {NIN: [8, 9, 10]}}) {
    _id
    id
    title
    vehicles {
      _id
      dateFrom
      dateTo
      ... on InternalVehicle {
        internalNumberUnknown
        eqVehicle {
          _id
          id
          label
        }
        label
      }
    }
    provingGround {
      _id
      title
    }
  }
}
    `;

    export function useDoubleBookingsVehiclesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DoubleBookingsVehiclesQuery, DoubleBookingsVehiclesQueryVariables>) {
      return ApolloReactHooks.useQuery<DoubleBookingsVehiclesQuery, DoubleBookingsVehiclesQueryVariables>(DoubleBookingsVehiclesDocument, baseOptions);
    };
      export function useDoubleBookingsVehiclesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DoubleBookingsVehiclesQuery, DoubleBookingsVehiclesQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<DoubleBookingsVehiclesQuery, DoubleBookingsVehiclesQueryVariables>(DoubleBookingsVehiclesDocument, baseOptions);
      };
      
export type DoubleBookingsVehiclesQueryHookResult = ReturnType<typeof useDoubleBookingsVehiclesQuery>;
export type DoubleBookingsVehiclesQueryResult = ApolloReactCommon.QueryResult<DoubleBookingsVehiclesQuery, DoubleBookingsVehiclesQueryVariables>;
export const DoubleBookingsResourceBookingsListDocument = gql`
    query DoubleBookingsResourceBookingsList {
  cachedProvings(filter: {status: {NIN: [8, 9, 10]}}) {
    _id
    resourceBookings {
      dateFrom
      dateTo
      resource {
        _id
      }
    }
  }
}
    `;

    export function useDoubleBookingsResourceBookingsListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DoubleBookingsResourceBookingsListQuery, DoubleBookingsResourceBookingsListQueryVariables>) {
      return ApolloReactHooks.useQuery<DoubleBookingsResourceBookingsListQuery, DoubleBookingsResourceBookingsListQueryVariables>(DoubleBookingsResourceBookingsListDocument, baseOptions);
    };
      export function useDoubleBookingsResourceBookingsListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DoubleBookingsResourceBookingsListQuery, DoubleBookingsResourceBookingsListQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<DoubleBookingsResourceBookingsListQuery, DoubleBookingsResourceBookingsListQueryVariables>(DoubleBookingsResourceBookingsListDocument, baseOptions);
      };
      
export type DoubleBookingsResourceBookingsListQueryHookResult = ReturnType<typeof useDoubleBookingsResourceBookingsListQuery>;
export type DoubleBookingsResourceBookingsListQueryResult = ApolloReactCommon.QueryResult<DoubleBookingsResourceBookingsListQuery, DoubleBookingsResourceBookingsListQueryVariables>;
export const DoubleBookingsResourceBookingsDocument = gql`
    query DoubleBookingsResourceBookings {
  cachedProvings(filter: {status: {NIN: [8, 9, 10]}}) {
    _id
    id
    department
    resourceBookings {
      dateFrom
      dateTo
      resource {
        _id
        title
      }
    }
    provingGround {
      _id
      title
    }
  }
}
    `;

    export function useDoubleBookingsResourceBookingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DoubleBookingsResourceBookingsQuery, DoubleBookingsResourceBookingsQueryVariables>) {
      return ApolloReactHooks.useQuery<DoubleBookingsResourceBookingsQuery, DoubleBookingsResourceBookingsQueryVariables>(DoubleBookingsResourceBookingsDocument, baseOptions);
    };
      export function useDoubleBookingsResourceBookingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DoubleBookingsResourceBookingsQuery, DoubleBookingsResourceBookingsQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<DoubleBookingsResourceBookingsQuery, DoubleBookingsResourceBookingsQueryVariables>(DoubleBookingsResourceBookingsDocument, baseOptions);
      };
      
export type DoubleBookingsResourceBookingsQueryHookResult = ReturnType<typeof useDoubleBookingsResourceBookingsQuery>;
export type DoubleBookingsResourceBookingsQueryResult = ApolloReactCommon.QueryResult<DoubleBookingsResourceBookingsQuery, DoubleBookingsResourceBookingsQueryVariables>;
export const GenerateExcelOerviewDocument = gql`
    mutation GenerateExcelOerview($id: String!) {
  excelOverview(id: $id)
}
    `;
export type GenerateExcelOerviewMutationFn = ApolloReactCommon.MutationFunction<GenerateExcelOerviewMutation, GenerateExcelOerviewMutationVariables>;

    export function useGenerateExcelOerviewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GenerateExcelOerviewMutation, GenerateExcelOerviewMutationVariables>) {
      return ApolloReactHooks.useMutation<GenerateExcelOerviewMutation, GenerateExcelOerviewMutationVariables>(GenerateExcelOerviewDocument, baseOptions);
    };
export type GenerateExcelOerviewMutationHookResult = ReturnType<typeof useGenerateExcelOerviewMutation>;
export type GenerateExcelOerviewMutationResult = ApolloReactCommon.MutationResult<GenerateExcelOerviewMutation>;
export type GenerateExcelOerviewMutationOptions = ApolloReactCommon.BaseMutationOptions<GenerateExcelOerviewMutation, GenerateExcelOerviewMutationVariables>;
export const AcceptedProvingChangesDocument = gql`
    query AcceptedProvingChanges($id: String!) {
  acceptedProvingChanges(provingId: $id) {
    _id
    provingId
    status
    change {
      key
      type
      path
      value
      valueType
      oldValue
      relativePath
    }
    created
    createdBy {
      _id
      type
      upn
      firstName
      lastName
      name
      email
      department
      employeeId
    }
    resolved
    resolvedBy {
      _id
      type
      upn
      firstName
      lastName
      name
      email
      department
      employeeId
    }
  }
}
    `;

    export function useAcceptedProvingChangesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AcceptedProvingChangesQuery, AcceptedProvingChangesQueryVariables>) {
      return ApolloReactHooks.useQuery<AcceptedProvingChangesQuery, AcceptedProvingChangesQueryVariables>(AcceptedProvingChangesDocument, baseOptions);
    };
      export function useAcceptedProvingChangesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AcceptedProvingChangesQuery, AcceptedProvingChangesQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<AcceptedProvingChangesQuery, AcceptedProvingChangesQueryVariables>(AcceptedProvingChangesDocument, baseOptions);
      };
      
export type AcceptedProvingChangesQueryHookResult = ReturnType<typeof useAcceptedProvingChangesQuery>;
export type AcceptedProvingChangesQueryResult = ApolloReactCommon.QueryResult<AcceptedProvingChangesQuery, AcceptedProvingChangesQueryVariables>;